import React from "react";

type RowContainer = {
  children?: unknown;
  detailRows?: unknown;
} & Record<string, unknown>;

export function getSettingsListValueByPath(record: unknown, path: string): unknown {
  if (record == null || path === "") return undefined;
  const parts = path.split(".");
  let current: unknown = record;
  for (const part of parts) {
    if (current == null || typeof current !== "object") return undefined;
    current = (current as Record<string, unknown>)[part];
  }
  return current;
}

export function settingsListDataIndexPath(dataIndex: unknown): string {
  if (Array.isArray(dataIndex)) return dataIndex.map(String).join(".");
  return dataIndex == null ? "" : String(dataIndex);
}

export function getSettingsListNestedRows<T>(record: T, property: "children" | "detailRows"): T[] {
  if (record == null || typeof record !== "object") return [];
  const value = (record as RowContainer)[property];
  return Array.isArray(value) ? (value as T[]) : [];
}

export function collectSettingsListRows<T>(items: T[] | null | undefined, limit = Number.POSITIVE_INFINITY): T[] {
  const records: T[] = [];
  const collect = (rows: T[] | null | undefined) => {
    if (!rows || records.length >= limit) return;
    for (const row of rows) {
      records.push(row);
      if (records.length >= limit) return;
      collect(getSettingsListNestedRows(row, "children"));
      if (records.length >= limit) return;
      collect(getSettingsListNestedRows(row, "detailRows"));
      if (records.length >= limit) return;
    }
  };
  collect(items);
  return records;
}

export function formatSettingsListScalar(value: unknown): string | null {
  if (value == null || value === "") return null;
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean" || typeof value === "bigint") return String(value);
  return null;
}

export function safeSettingsListCellNode(node: unknown): React.ReactNode {
  // Ausdrücklich typisiert: ohne `strictNullChecks` (Consumer mit lockerer JavaScript-Prüfung) engt `unknown` hier nicht ein.
  if (node === null || node === undefined || node === "") return node as null | undefined | "";
  if (typeof node === "string" || typeof node === "number" || typeof node === "boolean") return node;
  if (React.isValidElement(node)) return node;
  if (Array.isArray(node)) return node.map(safeSettingsListCellNode);
  return "—";
}
